export const coldShouldersLyrics = [
  { text: "The funny thing about love", start: 0, end: 2.35 },
  { text: "Is", start: 2.35, end: 4 },
  { text: "You either find yourself", start: 4, end: 5.3 },
  { text: "Or you lose yourself", start: 5.3, end: 7.3 },
  { text: "If you're lucky enough to experience", start: 7.3, end: 10 },
  { text: "At least one of the outcomes", start: 10, end: 11.791 },
  { text: "You didn't love like a coward", start: 11.791, end: 14.60 },
  { text: "Cold", start: 14.60, end: 16.7 },
  { text: "Cold", start: 16.7, end: 17.3 },
  { text: "Shoulder", start: 17.3, end: 18.5 },
  { text: "Cold", start: 18.5, end: 19.5 },
  { text: "Cold", start: 19.5, end: 20 },
  { text: "Shoulder", start: 20, end: 21.7 },
  { text: "Cold", start: 21.7, end: 22.5 },
  { text: "Cold", start: 22.5, end: 23 },
  { text: "Shoulder", start: 23, end: 24 },
  { text: "Cold", start: 24, end: 24.7 },
  { text: "Cold", start: 24.7, end: 25.7 },
  { text: "Shoulder", start: 25.7, end: 27 },
  { text: "Cold", start: 27, end: 27.7 },
  { text: "Cold", start: 27.7, end: 28.2 },
  { text: "Shoulder", start: 28.2, end: 29.5 },
  { text: "Cold", start: 29.5, end: 30 },
  { text: "Cold", start: 30, end: 30.7 },
  { text: "Shoulder", start: 30.7, end: 32},
  { text: "Cold", start: 32, end: 32.7 },
  { text: "Cold", start: 32.7, end: 33.5 },
  { text: "Shoulder", start: 33.5, end: 34.5 },
  { text: "Cold", start: 34.5, end: 35 },
  { text: "Cold", start: 35, end: 36 },
  { text: "Shoulder", start: 36, end: 37 },
  { text: "I am out here standing in the cold", start: 37, end: 39.09 },
  { text: "When he calls I put my needs on hold", start: 39.09, end: 41.89 },
  { text: "An addiction for cupids arrow.", start: 41.89, end: 44.44 },
  { text: "I'm not stranger to paying love's tolls", start: 44.44, end: 47.35 },
  { text: "But I can't afford", start: 47.35, end: 48.5 },
  { text: "The levels you go", start: 48.5, end: 50.2 },
  { text: "Bend my ears till I'd go for broke", start: 50.2, end: 52.3 },
  { text: "When the ego convinces the soul", start: 52.3, end: 55.19 },
  { text: "Leave you lose but to stay makes you strong", start: 55.19, end: 57.96 },
  { text: "As if my eyes weren't open", start: 57.96, end: 63.58 },
  { text: "Confusing potential with capacity", start: 63.58, end: 69.97 },
  { text: "As if our sky's were closing", start: 69.97, end: 74.37 },
  { text: "When I'm with you I'm my own worst enemy", start: 74.37, end: 80.5 },
  { text: "Cold", start: 80, end: 80.7 },
  { text: "Cold", start: 80.7, end: 81.3 },
  { text: "Shoulder", start: 81.3, end: 82 },
  { text: "Cold", start: 82, end: 82.7 },
  { text: "Cold", start: 82.7, end: 83.5 },
  { text: "Shoulder", start: 83.5, end: 85 },
  { text: "Cold", start: 85, end: 85.8 },
  { text: "Cold", start: 85.8, end: 86.5 },
  { text: "Shoulder", start: 86.5, end: 88 },
  { text: "Cold", start: 88, end: 88.8 },
  { text: "Cold", start: 88.8, end: 89.5 },
  { text: "Shoulder", start: 89.5, end: 90.2 },
  { text: "Cold", start: 90.2, end: 91 },
  { text: "Cold", start: 91, end: 91.7 },
  { text: "Shoulder", start: 91.7, end: 92.8 },
  { text: "Cold", start: 92.8, end: 93.5 },
  { text: "Cold", start: 93.5, end: 94.3 },
  { text: "Shoulder", start: 94.3, end: 95 },
  { text: "Cold", start: 95, end: 95.7 },
  { text: "Cold", start: 95.7, end: 96.8 },
  { text: "Shoulder", start: 96.8, end: 98.7 },
  { text: "Cold", start: 98.7, end: 99.3 },
  { text: "Cold", start: 99.3, end: 100 },
  { text: "Shoulder", start: 100, end: 101 },
  { text: "You made love blind", start: 101, end: 102 },
  { text: "My love cold", start: 102, end: 103 },
  { text: "You were mine", start: 103, end: 104 },
  { text: "But not mine to hold", start: 104, end: 106.1 },
  { text: "I've finally let me,", start: 106.1, end: 107.5 },
  { text: "Let me let you go", start: 107.5, end: 108.89 },
  { text: "But with these two hands I still hold", start: 108.89, end: 111.2 },
  { text: "A head so heavy trying to understand", start: 111.2, end: 114.4 },
  { text: "The lengths that I would go", start: 114.4, end: 116.5 },
  { text: "Forcing you", start: 116.5, end: 117.5 },
  { text: "To finally realize", start: 117.5, end: 119.25 },
  { text: "I'm worthy of your love", start: 119.25, end: 122 },
  { text: "Can't keep lovin' you", start: 122, end: 123.49 },
  { text: "You you you you", start: 123.49, end: 125 },
  { text: "I just lose to me more (more more more more)", start: 125, end: 127.8 },
  { text: "Your love's cost me babies", start: 127.8, end: 129.7 },
  { text: "Thank God he didn't give me what I wanted", start: 129.7, end: 133 },
  { text: "Can't keep lovin' you you you", start: 133, end: 134.33 },
  { text: "You you you you", start: 134.33, end: 135 },
  { text: "cause when I'm in your arms", start: 135, end: 137.5 },
  { text: "I let you drive me crazy", start: 137.5, end: 140 },
  { text: "Baby baby", start: 140, end: 141 },
  { text: "Can't keep losing me to who you are", start: 141, end: 143.76 },
  { text: "Said you loved me", start: 143.76, end: 145 },
  { text: "Said you need me", start: 145, end: 146.1 },
  { text: "Said you loved me", start: 146.1, end: 147.6 },
  { text: "But you lied", start: 147.6, end: 148.66 },
  { text: "They say love don't sure don't come easy", start: 148.66, end: 151.2 },
  { text: "You give and you get some it comes with a price", start: 151.2, end: 154.05 },
  { text: "Let you love me", start: 154.05, end: 155.5 },
  { text: "Let you lead me", start: 155.5, end: 157 },
  { text: "On too long still I loved you despite", start: 157, end: 159.13 },
  { text: "If you loved me you wouldn't mislead me", start: 159.13, end: 161.90 },
  { text: "You give and you get some it comes with a price", start: 161.90, end: 164.7 },
  { text: "The thing about love is…", start: 164.7, end: 167 },
  { text: "Cold", start: 168, end: 168.5 },
  { text: "Cold", start: 168.5, end: 169 },
  { text: "Shoulder", start: 169, end: 170 },
  { text: "Cold", start: 170, end: 170.8 },
  { text: "Cold", start: 170.8, end: 172 },
  { text: "Shoulder", start: 172, end: 173 },
  { text: "Cold", start: 173, end: 173.8 },
  { text: "Cold", start: 173.8, end: 174.5 },
  { text: "Shoulder", start: 174.5, end: 175.8 },
  { text: "Cold", start: 175.8, end: 176.3 },
  { text: "Cold", start: 176.3, end: 177 },
  { text: "Shoulder", start: 177, end: 179 },
  { text: "Cold", start: 179, end: 179.8 },
  { text: "Cold", start: 179.8, end: 180.5 },
  { text: "Shoulder", start: 180.5, end: 181.5 },
  { text: "Cold", start: 181.5, end: 182 },
  { text: "Cold", start: 182, end: 182.5 },
  { text: "Shoulder", start: 182.5, end: 183.6 },
  { text: "Cold", start: 183.6, end: 184.2 },
  { text: "Cold", start: 184.2, end: 185 },
  { text: "Shoulder", start: 185, end: 186.5 },
  { text: "Cold", start: 186.5, end: 187 },
  { text: "Cold", start: 187.5, end: 187.5 },
  { text: "Shoulder", start: 187.5, end: 189 },
  { text: "Said you loved me", start: 189, end: 190.3 },
  { text: "Said you need me", start: 190.3, end: 191.6 },
  { text: "Said you loved me", start: 191.6, end: 192.5 },
  { text: "But you lied", start: 192.5, end: 193.96 },
  { text: "They say love don't sure don't come easy", start: 193.96, end: 196.4 },
  { text: "You give and you get some it comes with a price", start: 196.4, end: 199.05 },
  { text: "Let you love me", start: 199.05, end: 200.8 },
  { text: "Let you lead me", start: 200.8, end: 202.17 },
  { text: "On too long still I loved you despite", start: 202.17, end: 204.5 },
  { text: "If you loved me you wouldn't mislead me", start: 204.5, end: 207 },
  { text: "You give and you get some it comes with a price", start: 207, end: 214.5 },
  { text: "Gameover", start: 214.5, end: 216.64 },
] as const satisfies ReadonlyArray<{ readonly text: string, readonly start?: number, readonly end?: number }>;
